import { defineMessage } from '../../../../services/localization';

export const messages = {
    hasMore: defineMessage('first_count_items_are_s_hat_you_are_looking_for'),
};
